import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';
import { Button, Grid, Select, MenuItem, FormControl, DialogActions } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import NumberField from 'components/library/NumberField';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import AccountServices from 'services/AccountServices';
import { roundOff } from 'helpers/NumberFormatHelper';

function AddPaymentPopup(props) {
  const { t: tCommon } = useTranslation('common');
  const { togglePaymentTab, addPaymentToVendor, currentBalance } = props;
  const [debitAmount, setDebitAmount] = useState();
  const [finalBalance, setFinalBalance] = useState();
  const [paymentTime, setPaymentTime] = useState(new Date());
  const [accountHeads, setAccountHeads] = useState([]);
  const [selectedAccountHead, setSelectedAccountHead] = useState('');

  useEffect(() => {
    const fetchAccountHeads = async () => {
      try {
        const heads = await AccountServices.getAccountHeads();
        setAccountHeads(heads);
        if (heads && heads.length > 0) {
          setSelectedAccountHead(heads[0].id);
        }
      } catch (err) {
        console.error('Failed to fetch account heads:', err);
      }
    };
    fetchAccountHeads();
  }, []);

  const addPayment = () => {
    let data = {
      debit: debitAmount,
      payment_time: new Date(paymentTime).toISOString(),
      payment_mode_id: selectedAccountHead || null,
      payment_modes: selectedAccountHead ? [{ account_head_id: selectedAccountHead, amount: Number(debitAmount) }] : [],
    };
    addPaymentToVendor(data);
  };

  const calculateBydebitAmount = (amt) => {
    let balance = roundOff(currentBalance + Number(amt));
    setDebitAmount(amt);
    setFinalBalance(balance);
  };

  const calculateByFinalBalance = (balance) => {
    let amt = roundOff(balance - currentBalance);
    setDebitAmount(amt);
    setFinalBalance(balance);
  };

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{tCommon('Add Payment')}</h2>
          <CloseIcon
            onClick={() => {
              togglePaymentTab('');
            }}
          />
        </div>
        <div className={styles.inputSec}>
          <Grid container className={styles.inputRow} alignItems="center">
            <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
              <h3 className={styles.labelInput}>{tCommon('Balance')}</h3>
            </Grid>
            <Grid item xs={8} sm={8} spacing={2} className={styles.inputLabelContainer}>
              <h3 className={styles.labelInput}>{currentBalance}</h3>
            </Grid>
          </Grid>

          <Grid container className={styles.inputRow} alignItems="center">
            <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
              <h3 className={styles.labelInput}>{tCommon('Account Head')}</h3>
            </Grid>
            <Grid item xs={8} sm={8}>
              <FormControl variant="outlined" size="small" fullWidth>
                <Select
                  value={selectedAccountHead}
                  onChange={(e) => setSelectedAccountHead(e.target.value)}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                    transformOrigin: {
                      vertical: 'top',
                      horizontal: 'left',
                    },
                    getContentAnchorEl: null,
                    PaperProps: {
                      style: {
                        maxHeight: 250,
                      },
                    },
                  }}
                >
                  {accountHeads.map((ah) => (
                    <MenuItem key={ah.id} value={ah.id}>
                      {ah.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container className={styles.inputRow} alignItems="center">
            <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
              <h3 className={styles.labelInput}>{tCommon('Payment Date')}</h3>
            </Grid>
            <Grid item xs={8} sm={8}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePicker
                  ampm
                  format="dd/MM/yyyy hh:mm a"
                  value={paymentTime}
                  onChange={(paymentTime) => {
                    setPaymentTime(paymentTime);
                  }}
                  slotProps={{
                    textField: {
                      variant: 'outlined',
                      fullWidth: true,
                      size: 'small',
                      margin: 'none',
                      id: 'date-payment',
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
          <Grid container className={styles.inputRow} alignItems="center">
            <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
              <h3 className={styles.labelInput}>{tCommon('Debit Amount') || 'Debit Amount'}</h3>
            </Grid>
            <Grid item xs={8} sm={8}>
              <NumberField value={debitAmount} onChange={(e) => calculateBydebitAmount(e.target.value)} />
            </Grid>
          </Grid>
          <Grid container className={styles.inputRow} alignItems="center">
            <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
              <h3 className={styles.labelInput}>{tCommon('Final Balance')}</h3>
            </Grid>
            <Grid item xs={8} sm={8}>
              <NumberField
                className={styles.labelInput}
                value={finalBalance}
                onChange={(e) => calculateByFinalBalance(e.target.value)}
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.footSec}>
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              size="small"
              onClick={togglePaymentTab}
              className={styles.closeBtn}
            >
              {tCommon('Close')}
            </Button>
            <Button
              variant="contained"
              size="small"
              color="primary"
              style={{ backgroundColor: '#00a65a' }}
              disabled={debitAmount === ''}
              onClick={addPayment}
            >
              {tCommon('Add Payment')}
            </Button>
          </DialogActions>
        </div>
      </div>
    </div>
  );
}

export default AddPaymentPopup;
